import React, { Component } from 'react';
import {
  ScrollView,
  StyleSheet,
  Text,
  View,
} from 'react-native';

import EonnTitle from '../components/title';
import EonnButton from '../components/button';
import { mstyles } from '../constants/MainStyles';

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 25,
    marginBottom: 10,
  },
  listItem: {
    fontSize: 16,
    marginBottom: 8,
    paddingLeft: 15,
  },
  note: {
    fontSize: 16,
    marginTop: 20,
    marginBottom: 8,
    fontStyle: 'italic',
  },
  noteItem: {
    fontSize: 16,
    marginBottom: 8,
    paddingLeft: 15,
  },
});

export default class Screen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
        <EonnTitle>Set Up Stripe (Optional)</EonnTitle>
        
        <Text style={[mstyles.text, {marginBottom: 20}]}>
          You can start taking consultation requests now. Set up Stripe anytime to withdraw your earnings.
        </Text>
{/* 
        <Text style={[mstyles.mfont, styles.sectionTitle]}>What You'll Need to Set Up Stripe</Text>
        
        <Text style={[mstyles.mfont, styles.sectionTitle, {fontSize: 16, marginTop: 15}]}>As an Individual</Text>
        <Text style={[mstyles.mfont, styles.listItem]}>• Legal name, date of birth, and home address</Text>
        <Text style={[mstyles.mfont, styles.listItem]}>• Social Security Number (SSN)</Text>
        <Text style={[mstyles.mfont, styles.listItem]}>• Bank account details to receive payments</Text>

        <Text style={[mstyles.mfont, styles.sectionTitle, {fontSize: 16, marginTop: 15}]}>As a Business Owner</Text>
        <Text style={[mstyles.mfont, styles.listItem]}>• Business name, EIN, and business address</Text>
        <Text style={[mstyles.mfont, styles.listItem]}>• Personal details for a business representative, such as the company's owner</Text>
        <Text style={[mstyles.mfont, styles.listItem]}>• Bank account details to receive payments</Text> */}

        <Text style={[mstyles.mfont, styles.sectionTitle]}>Important Notes</Text>
        <Text style={[mstyles.mfont, styles.noteItem]}>• If you already have a Stripe account, just sign in and connect it.</Text>
        <Text style={[mstyles.mfont, styles.noteItem]}>• When asked to select your industry, choose "Consultation."</Text>
        <Text style={[mstyles.mfont, styles.noteItem]}>• Stripe may request additional details to confirm your identity or business.</Text>

        <EonnButton
          navigationProps={this.props.navigation}
          onPress={() => {
            this.props.navigation.navigate("T_Profile7_Stripe");
          }}
        >
          Continue to Stripe
        </EonnButton>

        <EonnButton
          navigationProps={this.props.navigation}
          white={true}
          onPress={() => this.props.navigation.navigate("T_Home")}
        >
          Do this later
        </EonnButton>
      </ScrollView>
    );
  }
}
